<template>
  <!-- 公文流转各个列表页下拉筛选 -->
  <div class="select-con">
    <div>
      <div class="title" v-if="!isShowV">
        关键字查找
      </div>
      <van-search style="padding: 8px;" v-if="!isShowV" v-model="KeyWord" placeholder="请输入访客/访客手机号" />
      <div class="title">
        拜访时间
      </div>
      <div class="choose-time">
        <div class="start" @click="isShowStartDate = true">
          <!-- <span>开始时间</span> -->
          <div class="van-hairline--surround f14" style="margin-left:8px">
            <em v-if="startDate === ''">请选择</em>
            <p v-else class="top">{{startDate}}</p>
          </div>
        </div>
        <!-- <div class="center">
          <van-icon name="arrow" />
        </div> -->
        <!-- <div class="end" @click="isShowEndDate = true">
          <span>结束时间</span>
          <div class="van-hairline--surround f14">
            <em v-if="endDate === ''">请选择</em>
            <p v-else class="top">{{endDate}}</p>
          </div>
        </div> -->
      </div>
      <radio-select v-model="approvalStatus" v-if="isShowV"
              title="审批状态"
              :selectList="typeStatusList" />
      <radio-select v-model="leaveType" v-if="isShowV"  style="padding-bottom: 72px;"
              title="拜访状态"
              :selectList="typeList" />              
      <radio-select v-model="interviewType" v-if="!isShowV" style="padding-bottom: 72px;"
              title="状态筛选"
              :selectList="interviewStatusSon" /> 
      <!-- 筛选按钮 -->
      <div class="two-bottom-btn">
        <van-button round type="info" plain class="cancel" @click="resetCondition">重置</van-button>
        <van-button round type="info" class="submit" @click="confirmCondition">确定</van-button>
      </div>
    </div>
    <van-popup v-model="isShowStartDate" position="bottom" :style="{ height: '45%' }">
      <van-datetime-picker
        v-model="startCurrentDate"
        @cancel="startCancel"
        @confirm="startConfirm"
        :formatter="formatter"
        type="date"
      ></van-datetime-picker>
    </van-popup>
    <!-- <van-popup v-model="isShowEndDate" position="bottom" :style="{ height: '45%' }">
      <van-datetime-picker
        v-model="endCurrentDate"
        @confirm="endConfirm"
        :formatter="formatter"
        type="date"
      ></van-datetime-picker>
    </van-popup> -->
  </div>
</template>
<script>
// import { Notify } from 'vant';
import RadioSelect from './../../attendance/components/RadioSelect'
export default {
  name: "OfficeSelectChoose",
  props: {
    setCondition: {
      type: Function,
    },
    txt: {
      type: String,
    },
    approvalStatusSon:{
      type:Array
    },
    visitStatusSon:{
      type:Array
    },
    interviewStatusSon:{
      type:Array
    },
    isFromProps:{
      type:String
    }
  },
  components: {
    RadioSelect,
  },
  data() {
    return {
      KeyWord:'',//搜索
      radio: "1", //1不限 2自定义时间范围
      //date搜索
      maxDate: new Date(), //new Date(2019, 11, 20),

      isShowStartDate: false,
      startCurrentDate: new Date(),
      startDate: '', //开始时间
      startHour: '',

      isShowEndDate: false,
      endDate: '', //结束时间
      endHour: '',
      endCurrentDate: new Date(),

      //拜访状态
      leaveType: 0,
      typeList: [],
      //审批状态
      approvalStatus: 0,
      typeStatusList: [],
      //根据角色显示
      isShowV:true,
      //受访者状态
      interviewType:0
    };
  },
  created() {
    if(this.isFromProps === 'interview'){
      this.isShowV = false
    }
    console.log(this.isFromProps)
      console.log(this.txt)
      this.getTeacherLeaveType()
      console.log(this.approvalStatusSon)
        console.log(this.visitStatusSon)
      // this.getTeacherStateArr()
      },
 mounted(){
          // this.approvalStatusSon.forEach((item)=>{
          //   this.typeStatusList.push(item)
          // })
          console.log(this.approvalStatusSon)
          this.typeStatusList = this.approvalStatusSon
          this.typeList = this.visitStatusSon
          // this.typeStatusList.map((item)=>{
          //   console.log(item)
          // })
            console.log(this.typeStatusList)
        console.log(this.typeList)
 },     
  methods: {
    async getTeacherLeaveType() {
        // let that = this;
        // let res = await this.xyapi.get(this.$store.state.apiPath + '/api/TeacherLeaveType/GetAll');
        // if (res.success) {
        //   this.typeList = [{id: 0, name:'不限'}]
        //   res.data.length && res.data.forEach(function (value) {
        //     that.typeList.push({
        //       name: value.TeacherLeaveTypeName,
        //       id: value.TeacherLeaveTypeID
        //     })
        //   })
        // } else {
        //   Notify({type: 'danger', message: res.msg});
        // }
        // this.typeList = [
        //   {name:'不限',id:1},
        //   {name:'待拜访',id:2},
        //   {name:'已拜访',id:3},
        //   {name:'已逾期',id:4}
        // ]
                  // this.typeStatusList =  this.approvalStatusSon
          // this.typeList = this.visitStatusSon
      },
      // async getTeacherStateArr() {
      //   let that = this;
      //   let res = await this.xyapi.get(this.$store.state.apiPath + '/api/TeacherLeave/GetLeaveApplicationTypeList');
      //   if (res.success) {
      //     res.data.length && res.data.forEach(function (value) {
      //       that.typeStatusList.push({
      //         name: value.ApplicationStateID === 99 ? '不限' : value.ApplicationStateName,
      //         id: value.ApplicationStateID
      //       })
      //     })
      //   } else {
      //     Notify({type: 'danger', message: res.msg});
      //   }
      // },
      //取消
      resetCondition() {
        this.leaveType = 0;
        this.approvalStatus = 0;
        this.interviewType = 0
        this.radio = '1'
        this.startDate = '';
        this.endDate = '';
        this.txt = ''
        this.KeyWord = ''
      },
      //确定
      confirmCondition() {
         this.setCondition(this.leaveType, this.approvalStatus, this.startDate, this.interviewType,this.KeyWord)
        console.log(this.leaveType, this.approvalStatus, this.startDate, this.interviewType,this.KeyWord)
      },
    //radio触发事件,再次点击自定义时清空上次选项
    radioChange(val) {
      console.log(val);
      if(val === '2'){
        this.startDate = '';
        this.endDate = '';
      }
    },
    //取消选择开始时间
    startCancel() {
      this.isShowStartDate = false;
    },
    //确认选择开始时间
    startConfirm(value) {
      this.startDate = value.pattern("yyyy/MM/dd");
      this.isShowStartDate = false;
    },
    //取消选择结束时间
    // endCancel() {
    //   this.isShowEndDate = false;
    // },
    //确认选择结束时间
    // endConfirm(value) {
    //   this.endDate = value.pattern("yyyy.MM.dd");
    //   this.isShowEndDate = false;
    // },
    //选项格式化
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      } else if (type === "hour") {
        return `${value}时`;
      } else if (type === "minute") {
        return `${value}分`;
      }
      return value;
    },
  }
};
</script>
<style lang="less" scoped>
.van-search .van-cell{
  padding: 18px 20px !important;
}
.select-con {
  position: fixed;
  width: 100%;
  height: calc(100% - 170px);
  left: 0;
  top: 170px;
  z-index: 9;
  //background: rgba(0, 0, 0, 0.5); //弹框展示一半时的黑色遮罩
  > div {
    width: 100%;
    height: 87%;
    padding: 0 39px;
    background: #fff;
    border-top: 2px solid #dedede;
    overflow: overlay;
    .choose-time {
      display: flex;
      .start,
      .end {
        .f14{
          line-height: 90px;
        }
        width: 40%;
        > span {
          display: block;
          color: #666;
          font-size: 26px;
          margin-bottom: 26px;
        }
        > div {
          height: 120px;
          background: #f5faff;
          border-radius: 8px;
          padding: 20px 0 0 30px;
          p.top {
            color: #666;
            margin-bottom: 12px;
          }
          p.bot {
            color: #111;
          }
          em {
            margin-left: 50px;
            line-height: 75px;
          }
        }
      }
      .center {
        width: 20%;
        text-align: center;
        margin-top: 15%;
        color: #999;
      }
    }
    .title {
      font-size: 28px;
      line-height: 110px;
      color: #111;
      position: relative;
      .radio-con {
        display: flex;
        position: absolute;
        top: 38px;
        left: 148px;
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 28%;
        margin-right: 8%;
        margin-bottom: 38px;
        height: 54px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(247, 247, 247, 1);
        border-radius: 8px;
        color: #333;
      }
      li.current {
        background: @blue;
        color: #fff;
      }
      li:nth-child(3n) {
        margin-right: 0;
      }
    }
    .two-bottom-btn {
      height: 150px;
      line-height: 150px;
      background: #000;
      background: rgba(255, 255, 255, 1);
      //box-shadow:0px 2px 21px 0px rgba(186,186,186,0.44);
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 38px 70px;
      display: flex;
      align-items: center;
      .cancel {
        flex: 1;
      }
      .submit {
        flex: 1;
        margin-left: 70px;
      }
    }
  }
}
</style>
